var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCategory(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 53,
    viewBox: "0 0 54 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.375 6.625H9.33333C8.1137 6.625 7.125 7.6137 7.125 8.83333V19.875C7.125 21.0946 8.1137 22.0833 9.33333 22.0833H20.375C21.5946 22.0833 22.5833 21.0946 22.5833 19.875V8.83333C22.5833 7.6137 21.5946 6.625 20.375 6.625Z",
    stroke: "url(#paint0_linear_5_92)",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.375 30.9167H9.33333C8.1137 30.9167 7.125 31.9054 7.125 33.125V44.1667C7.125 45.3863 8.1137 46.375 9.33333 46.375H20.375C21.5946 46.375 22.5833 45.3863 22.5833 44.1667V33.125C22.5833 31.9054 21.5946 30.9167 20.375 30.9167Z",
    stroke: "url(#paint1_linear_5_92)",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.6667 6.625H33.625C32.4054 6.625 31.4167 7.6137 31.4167 8.83333V19.875C31.4167 21.0946 32.4054 22.0833 33.625 22.0833H44.6667C45.8863 22.0833 46.875 21.0946 46.875 19.875V8.83333C46.875 7.6137 45.8863 6.625 44.6667 6.625Z",
    stroke: "url(#paint2_linear_5_92)",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.6667 30.9167H33.625C32.4054 30.9167 31.4167 31.9054 31.4167 33.125V44.1667C31.4167 45.3863 32.4054 46.375 33.625 46.375H44.6667C45.8863 46.375 46.875 45.3863 46.875 44.1667V33.125C46.875 31.9054 45.8863 30.9167 44.6667 30.9167Z",
    stroke: "url(#paint3_linear_5_92)",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5_92",
    x1: 22.5833,
    y1: 22.0833,
    x2: 9.12238,
    y2: 5.04682,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6246EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9BFF7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5_92",
    x1: 22.5833,
    y1: 46.375,
    x2: 9.12238,
    y2: 29.3385,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6246EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9BFF7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5_92",
    x1: 46.875,
    y1: 22.0833,
    x2: 33.414,
    y2: 5.04682,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6246EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9BFF7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_5_92",
    x1: 46.875,
    y1: 46.375,
    x2: 33.414,
    y2: 29.3385,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6246EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9BFF7"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategory);
export default __webpack_public_path__ + "static/media/category.3b8729141329bcbf5385d2f24bda6f5a.svg";
export { ForwardRef as ReactComponent };